// extracted by mini-css-extract-plugin
export default {"paper":"paper_paper__IAlhp","pattern":"paper_pattern__-kNgF","content":"paper_content__WYYqn","header":"paper_header__9bGhy","footer":"paper_footer__sfD7m"};